const ADMIN_TOKEN_KEY = "up-and-away-admin-token";

export const getAdminToken = () => sessionStorage.getItem(ADMIN_TOKEN_KEY);

export const setAdminToken = (token) =>
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);

export const clearAdminToken = () =>
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
